import { render } from "./DynamicChart.vue?vue&type=template&id=8d07a4ce&scoped=true"
import script from "./DynamicChart.vue?vue&type=script&lang=js"
export * from "./DynamicChart.vue?vue&type=script&lang=js"

import "./DynamicChart.vue?vue&type=style&index=0&id=8d07a4ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d07a4ce"]])

export default __exports__